/**
 * 更新引导状态
 * @api http://yapi.umu.work/project/603/interface/api/8626
 * @doc https://docs.google.com/spreadsheets/d/1qUD7k3Dl3FuU_cswVMeaYwIC1efNul1nAIbUswa-1yA/edit#gid=0
 */

import API from './api';
import { fetchData } from './fetch';

export const closeExpireDialog = () => {
    return fetchData(API.UPDATE_GUIDE_STATUS.url, API.STAT_LOG.type, { module_type: 9, status: 1 });
};
